import Swal from "sweetalert2";
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Panel from "@/shared/components/Panel";
import getTooltipStyles from '@/shared/helpers';
import React, { useState, useEffect } from "react";
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ClicksChartWrap = styled.div`
  margin-top: -30px;
`;

const DailyUsage = () => {
    const [charData, setCharData] = useState();
    const themeName = useSelector(state => state.theme.className);

    const handleModalClose = () => {
        setCharData(null);
    };

    const GetAPIUsageDetail = () => {
        AdminInterface.instance.getDailyUsage().then((response) => {
            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            let chart_data = {};
            let date = new Date()
            date.setHours(0, 0, 0, 0);

            for (let i = 0; i < 7; i++) {
                let current_week_date = new Date(date);
                let previous_week_date = new Date(date);
                previous_week_date.setDate(previous_week_date.getDate() - 7);

                chart_data[current_week_date.getTime()] = {
                    'Current Week': null,
                    'Last Week': null
                }

                for (let j = 0; j < 14; j++) {
                    let data_date = new Date(`${response.data[j]['date']}T00:00:00`);
                    if (data_date.getTime() === current_week_date.getTime()) {
                        chart_data[current_week_date.getTime()]['Current Week'] = response.data[j]['count'];
                    } else if (data_date.getTime() === previous_week_date.getTime()) {
                        chart_data[current_week_date.getTime()]['Last Week'] = response.data[j]['count'];
                    }
                }
                date.setHours(date.getHours() - 24);
            }

            let chart_organized_data = Object.keys(chart_data).map(key => {
                return {
                    'Day': days[new Date(parseInt(key)).getDay()],
                    'Current Week': chart_data[key]['Current Week'],
                    'Last Week': chart_data[key]['Last Week']
                };
            });

            setCharData(chart_organized_data);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        });
    }

    useEffect(() => {
        GetAPIUsageDetail();
    }, []);

    return (
        <Panel lg={6} xl={6} md={12} title='Daily API Usage' subhead="How effective FastMap APIs are in comparison with the previous week."
            dismissButton={() => handleModalClose()} refreshRequest={() => GetAPIUsageDetail()}>
            {charData && <ClicksChartWrap dir="ltr">
                <ResponsiveContainer height={500}>
                    <BarChart height={400} data={charData} layout="vertical" barGap={0} barCategoryGap={0} stackOffset="expand" >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis type="number" hide reversed={false} />
                        <YAxis type="category" dataKey="Day" tickLine={false} verticalAnchor="start" orientation={'right'} />
                        <Tooltip {...getTooltipStyles(themeName, 'defaultItems')} />
                        <Bar dataKey="Current Week" fill="#48b5ff" barSize={24} />
                        <Bar dataKey="Last Week" fill="#7edbff" barSize={24} />
                    </BarChart>
                </ResponsiveContainer>
            </ClicksChartWrap>}
            <h6>See more <Link to="/marketplace/apiusage">here</Link></h6>
        </Panel>
    );
};

export default DailyUsage;